import styled from 'styled-components';

export const StyledDayPreferences = styled.div`
   display: grid;
   grid-template-columns: 112px 280px;
   grid-template-rows: repeat(7, 1fr);
   grid-column-gap: 8px;
   grid-row-gap: 8px;
   align-items: center;
`;

StyledDayPreferences.displayName = 'StyledDayPreferences';
